import { useQuery } from '@apollo/client'
import { gql } from '@apollo/client'

// Wrapper to convert RedwoodJS Cell pattern to Apollo Client
export const useCell = (cellModule, props = {}) => {
  const { QUERY, beforeQuery, Loading, Empty, Failure, Success } = cellModule

  if (!QUERY) {
    // Not a cell, return the component directly
    return { component: cellModule }
  }

  const queryOptions = beforeQuery ? beforeQuery(props) : { variables: props }
  const { data, loading, error } = useQuery(QUERY, {
    ...queryOptions,
    skip: !QUERY,
  })

  if (loading) {
    return Loading ? <Loading /> : <div>Loading...</div>
  }

  if (error) {
    return Failure ? <Failure error={error} /> : <div>Error: {error.message}</div>
  }

  if (!data || Object.keys(data).length === 0) {
    return Empty ? <Empty {...props} /> : null
  }

  // Extract the first key from data (RedwoodJS pattern)
  const dataKey = Object.keys(data)[0]
  const cellData = data[dataKey]

  return <Success {...props} {...{ [dataKey]: cellData }} />
}

